import React from 'react';
import { useI18n as useI18nManager } from '@funtech-int/rival-react';

import { Link } from '@/shared/components/Link/Link';
import { getSubscriptionUrl } from '@/shared/lib/getSubscriptionUrl';

import { useI18n } from '../../hooks/useI18n';
import { Cell } from '../Cell/Cell';

import styles from './SubscriptionSettings.module.css';

export const SubscriptionSettings = () => {
    const { lang } = useI18nManager().locale.get();
    const i18n = useI18n();

    return (
        <Link href={getSubscriptionUrl(lang)} target="_blank">
            <Cell
                title={i18n('subscription_settings__title')}
                rightSection={<span className={styles.openLink} />}
                withHover
            />
        </Link>
    );
};
